import { Component, computed, inject, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { CurrentUserService } from '../../../../../common/current-user/current-user.service';
import { CreatorResponseDto } from '../../../../../common/general-types/creators.dto';
import { SocialPlatformsEnum } from '../../../../../common/general-types/super-social.dto';
import { GenericPostsDto } from '../../../../../common/general-types/super-social.dto';
import { SuperSocialService } from '../../../../../services/super-social/super-social.service';
import { FormatService } from '../../../../../common/format/format.service';
import { ImageService } from '../../../../../services/image/image.service';
import { forkJoin, Observable, Subscription, take } from 'rxjs';
import { MediaViewerSimplerComponent } from '../../../../../atoms/media-viewer-simpler/media-viewer-simpler.component';
import { LdgImgComponent } from '../../../../../atoms/ldg-img/ldg-img.component';
import { DecimalPipe, DatePipe } from '@angular/common';
import { LoadingInlineComponent } from '../../../../../atoms/loading-inline/loading-inline.component';
import { VideoThumbnailComponent } from '@/app/atoms/video-thumbnail/video-thumbnail.component';
import { HasRoleDirectiveDirective } from '../../../../../common/directives/has-role/has-role-directive.directive';
import { ToastNotificationService } from '../../../../../atoms/toast-notification/toast-notification.service';
import { UltraSocialService, UltraSocialSocialAccount } from '@/app/services/ultra-social/ultra-social';
import { MgcPortfolioInlineVideoComponent } from '../mgc-portfolio/mgc-portfolio-inline-video.component';
import { VideoResponseDto } from '../../../../../common/general-types/videos.dto';
import { VideoFormatEnum } from '@/app/common/general-types/briefs.dto';
import { DialogComponent } from '@/app/atoms/dialog/dialog.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

type UltraTiktokPost = {
  assetImageKeys: string[] | null;
  assetImageUrls: string[] | null;
  assetMediaKey: string | null;
  assetMediaUrl: string | null;
  assetThumbnailKey: string | null;
  assetThumbnailUrl: string | null;
  caption: string | null;
  commentCount: number;
  id: string;
  likeCount: number;
  permalink: string;
  postedAt: Date;
  shareCount: number;
  thumbnailUrl: string | null;
  type: string;
  viewCount: number;
};

@Component({
  selector: 'mgc-tiktok',
  standalone: true,
  imports: [LdgImgComponent, DecimalPipe,
    LoadingInlineComponent, VideoThumbnailComponent, MediaViewerSimplerComponent,
    HasRoleDirectiveDirective, DatePipe, MgcPortfolioInlineVideoComponent, DialogComponent],
  templateUrl: './mgc-tiktok.component.html',
  styleUrl: './mgc-tiktok.component.css'
})
export class MgcTiktokComponent implements OnInit, OnDestroy {
  @Input() creator!: CreatorResponseDto;
  @Input() ultra_social_tiktok: UltraSocialSocialAccount | undefined;
  @Input() ultra_social_creator_id: string | undefined;

  subscriptionList = new Subscription();

  tiktokBasics = signal<any>(undefined);
  tiktokPosts = signal<GenericPostsDto[] | undefined>(undefined);

  /** Ultra Social */
  utlra_tiktok_account = signal<{
    id: string;
    platform: "tiktok" | "instagram" | "youtube" | "snapchat";
    handle: string;
    displayName: string;
    avatarUrl: string;
    bio: string | null;
    status: string | null;
    followerCount: number;
    followingCount: number;
    likesCount: number;
    postCount: number;
  } | undefined>(undefined);

  utlra_tiktok_posts = signal<UltraTiktokPost[] | undefined>(undefined);
  /** Ultra Social END */

  SocialPlatformsEnum = SocialPlatformsEnum;

  refreshTiktokAccountLoading = signal<boolean>(false);
  accountRefreshed = signal<boolean>(false);
  accountOwnershipChanged = signal<boolean>(false);

  readonly embedVideoId = signal<string | undefined>(undefined);
  readonly tiktokEmbedOpen = computed(() => !!this.embedVideoId());
  readonly tiktokEmbedSrc = computed<SafeResourceUrl | null>(() => {
    const id = this.embedVideoId();
    if (!id) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.tiktok.com/player/v1/${encodeURIComponent(id)}?autoplay=1`,
    );
  });
  readonly tiktokWatchUrl = computed(() => {
    const id = this.embedVideoId();
    return id ? `https://www.tiktok.com/video/${id}` : undefined;
  });

  private currentUserService = inject(CurrentUserService);
  private readonly sanitizer = inject(DomSanitizer);

  readonly tiktokHandleRevealed = computed(() => this.currentUserService.subscriptionActive());

  /** Services */
  public superSocialService = inject(SuperSocialService);
  public formatService = inject(FormatService);
  public imageService = inject(ImageService);
  public toastNotificationService = inject(ToastNotificationService);
  public ultraSocialService = inject(UltraSocialService);
  /** Services - END */

  ngOnInit(): void {

    console.log('-----> ultra_social_tiktok', this.ultra_social_tiktok);

    if (this.ultra_social_creator_id && this.ultra_social_tiktok) {
      this.getUltraTiktokAccount(this.ultra_social_creator_id, this.ultra_social_tiktok.id);
    }

    else if (this.creator && this.creator.ssCreator && this.creator.ssCreator.tiktokAccountId && this.creator.ssCreator.tiktokAccountId !== 'Ownership Changed') {
      this.getSuperSocialTiktokAccount(this.creator.ssCreator.tiktokAccountId);
      this.getSuperSocialTiktokPosts(this.creator.ssCreator.tiktokAccountId);
    } else if (this.creator && this.creator.ssCreator && this.creator.ssCreator.tiktokAccountId && this.creator.ssCreator.tiktokAccountId == 'Ownership Changed') {

      console.log('-----> accountOwnershipChanged');
      this.accountOwnershipChanged.set(true);
      this.tiktokBasics.set(undefined);
      this.tiktokPosts.set([])
    }
    // else if (this.creator && this.creator.creatorSocialAccounts && this.creator.creatorSocialAccounts.length > 0) {
    //   /**
    //    * Does this creator have a TikTok account?
    //    */
    //   const ultra_tiktokAccount = this.creator.creatorSocialAccounts.find(account => account.platform === 'tiktok');
    //   if (ultra_tiktokAccount) {
    //     this.getUltraTiktokAccount(ultra_tiktokAccount.creatorId);
    //   }
    // }
  }

  ngOnDestroy(): void {
    this.subscriptionList.unsubscribe();
  }

  getSuperSocialTiktokAccount(tiktokAccountId: string) {
    this.subscriptionList.add(
      this.superSocialService.getSuperSocialTiktokAccount(tiktokAccountId).pipe(take(1)).subscribe({
        next: (superSocialTiktokAccount) => {
          console.log('superSocialTiktokAccount', superSocialTiktokAccount);
          this.tiktokBasics.set(superSocialTiktokAccount);
        },
        error: (err: unknown) => {
          console.error('Error loading Super Social TikTok account', err);
          this.tiktokBasics.set(undefined);
        },
      }),
    );
  }

  getSuperSocialTiktokPosts(tiktokAccountId: string) {
    this.subscriptionList.add(
      this.superSocialService.getTiktokDisplayContent(tiktokAccountId).pipe(take(1)).subscribe({
        next: (superSocialTiktokPosts) => {
          console.log('superSocialTiktokPosts', superSocialTiktokPosts);
          this.tiktokPosts.set(superSocialTiktokPosts ?? []);
        },
        error: (err: unknown) => {
          console.error('Error loading Super Social TikTok posts', err);
          this.tiktokPosts.set([]);
        },
      }),
    );
  }

  getUltraTiktokAccount(ultra_social_creator_id: string, socialAccountId: string) {
    this.subscriptionList.add(
      this.loadData(ultra_social_creator_id, socialAccountId).pipe(take(1)).subscribe({
        next: (data) => {
          console.log('ULTRA data', data);
          this.utlra_tiktok_account.set(data.account);
          this.utlra_tiktok_posts.set(data.posts ?? []);
        },
        error: (err: unknown) => {
          console.error('Error loading Ultra Social TikTok data', err);
          this.utlra_tiktok_account.set(undefined);
          this.utlra_tiktok_posts.set([]);
        },
      }),
    );
  }

  private loadData(ultra_social_creator_id: string, socialAccountId: string): Observable<{
    account: any;
    posts: any[];
  }> {
    return forkJoin({
      account: this.ultraSocialService.getSocialAccount(ultra_social_creator_id, socialAccountId),
      posts: this.ultraSocialService.getAccountPosts(ultra_social_creator_id, socialAccountId),
    });
  }

  getCoverImage(post: GenericPostsDto): string {
    return this.getUsableCoverUrl(post) ?? '/assets/images/placeholder-video.png';
  }

  getUsableCoverUrl(post: GenericPostsDto): string | undefined {
    const cover = post.tiktokVideoFile?.cover;
    if (this.isUsableMediaUrl(cover)) {
      return cover;
    }
    const carouselUrl = post.tiktokCarouselFile?.images?.[0]?.s3_url;
    if (this.isUsableMediaUrl(carouselUrl)) {
      return carouselUrl;
    }
    if (this.isUsableMediaUrl(post.image)) {
      return post.image;
    }
    return undefined;
  }

  superSocialVideoUrl(post: GenericPostsDto): string {
    return post.tiktokVideoFile?.s3_url ?? '';
  }

  tiktokVideoIdFromSource(source: string | null | undefined): string | undefined {
    if (!source) {
      return undefined;
    }
    const trimmed = source.trim();
    if (/^\d{8,}$/.test(trimmed)) {
      return trimmed;
    }
    const fromKnownPath = trimmed.match(/\/(?:player\/v1|video)\/(\d+)/i);
    if (fromKnownPath) {
      return fromKnownPath[1];
    }
    return undefined;
  }

  superSocialEmbedVideoId(post: GenericPostsDto): string | undefined {
    if (post.tiktokCarouselFile) {
      return undefined;
    }
    return (
      this.tiktokVideoIdFromSource(post.tiktokVideoFile?.tiktok_post_id) ??
      this.tiktokVideoIdFromSource(post.tiktokVideoFile?.post_id) ??
      this.tiktokVideoIdFromSource(post.tiktokVideoFile?.url) ??
      this.tiktokVideoIdFromSource(post.url)
    );
  }

  ultraEmbedVideoId(post: UltraTiktokPost): string | undefined {
    return this.tiktokVideoIdFromSource(post.permalink) ?? this.tiktokVideoIdFromSource(post.id);
  }

  openSuperSocialTiktokEmbed(post: GenericPostsDto): void {
    const id = this.superSocialEmbedVideoId(post);
    if (id) {
      this.embedVideoId.set(id);
    }
  }

  openUltraTiktokEmbed(post: UltraTiktokPost): void {
    const id = this.ultraEmbedVideoId(post);
    if (id) {
      this.embedVideoId.set(id);
    }
  }

  closeTiktokEmbed(): void {
    this.embedVideoId.set(undefined);
  }

  hasUltraVideoPreview(post: UltraTiktokPost): boolean {
    return !!(
      post.assetMediaUrl ||
      post.assetThumbnailUrl ||
      post.assetThumbnailKey ||
      this.isUsableMediaUrl(post.thumbnailUrl)
    );
  }

  ultraPostImageSrc(post: UltraTiktokPost): string | undefined {
    if (this.isUsableMediaUrl(post.assetImageUrls?.[0])) {
      return post.assetImageUrls![0];
    }
    if (post.assetImageKeys?.[0]) {
      return this.imageService.getImageSource(post.assetImageKeys[0], 'original');
    }
    return undefined;
  }

  ultraThumbnailUrl(post: UltraTiktokPost): string | undefined {
    const url =
      this.usableUrlOrEmpty(post.assetThumbnailUrl) || this.usableUrlOrEmpty(post.thumbnailUrl);
    return url || undefined;
  }

  ultraThumbnailCdnKey(post: UltraTiktokPost): string | undefined {
    return post.assetThumbnailKey ?? undefined;
  }

  allowedToRefreshInstagramAccount(updatedDate: Date): boolean {
    if (updatedDate) {
      const hoursAgo = Math.floor((new Date().getTime() - new Date(updatedDate).getTime()) / (1000 * 60 * 60));
      if (hoursAgo < 12) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }

  getUpdatedDateColour(updatedDate: Date): string {
    if (updatedDate) {
      const hoursAgo = Math.floor((new Date().getTime() - new Date(updatedDate).getTime()) / (1000 * 60 * 60));
      if (hoursAgo < 12) {
        return 'text-green-500';
      } else if (hoursAgo < 24) {
        return 'text-primary';
      } else if (hoursAgo < 48) {
        return 'text-amber-500';
      }
      else {
        return 'text-red-500';
      }
    }
    return 'text-gray-500';
  }

  refreshTiktokAccount() {
    console.log('-----> refreshTiktokAccount');
    this.refreshTiktokAccountLoading.set(true);

    if (this.creator.ssCreator && this.creator.ssCreator.tiktokAccountId && (this.creator.ssCreator.tiktokSource === 'tik_api' || this.creator.ssCreator.tiktokSource === 'apify' || !this.creator.ssCreator.tiktokSource)) {
      this.superSocialService.refreshTiktokTikApi(this.creator.ssCreator.tiktokAccountId).subscribe((refreshSent) => {
        console.log('refreshSent: ', refreshSent);
        this.refreshTiktokAccountLoading.set(false);
        this.accountRefreshed.set(true);
      }, err => {
        console.error('Error refreshing TikTok account: ', err);
        this.refreshTiktokAccountLoading.set(false);
        void this.toastNotificationService.alert({
          title: 'Error Refreshing Instagram Account!',
          message: 'Something went wrong. If the problem persists, please contact support.',
          type: 'error',
          icon: 'error'
        });
      });
    } else if (this.creator.ssCreator && this.creator.ssCreator.tiktokAccountId && this.creator.ssCreator.tiktokSource === 'tiktok_api') {
      this.superSocialService.refreshTiktokTikAuthentic(this.creator.ssCreator.tiktokAccountId).subscribe((refreshSent) => {
        console.log('refreshSent: ', refreshSent);
        this.refreshTiktokAccountLoading.set(false);
        this.accountRefreshed.set(true);
      }, err => {
        console.error('Error refreshing TikTok account: ', err);
        this.refreshTiktokAccountLoading.set(false);
        void this.toastNotificationService.alert({
          title: 'Error Refreshing Instagram Account!',
          message: 'Something went wrong. If the problem persists, please contact support.',
          type: 'error',
          icon: 'error'
        });
      });
    }
  }

  assembledVideoObject(post: UltraTiktokPost): VideoResponseDto {
    const thumbnailUrl =
      this.usableUrlOrEmpty(post.assetThumbnailUrl) ||
      this.usableUrlOrEmpty(post.thumbnailUrl);

    return {
      createdDate: post.postedAt,
      creator: this.creator,
      creatorId: this.creator.blazeFirebaseUid,
      fullUrl: post.assetMediaUrl ?? '',
      id: post.id,
      key: post.assetMediaKey ?? '',
      status: 1,
      thumbnail: thumbnailUrl,
      ugcBriefApplicationId: null,
      videoFormat: VideoFormatEnum.Vertical,
      videoLength: 0,
      videoName: post.caption ?? '',
      briefApplicationId: '',
      thumbnailURL: thumbnailUrl,
      thumbnailCdnKey: post.assetThumbnailKey,
    };
  }

  private isUsableMediaUrl(url: string | null | undefined): url is string {
    if (!url) {
      return false;
    }
    return !url.includes('www.tikwm.com') && !url.includes('ionicframework.com/docs/img/demos/thumbnail.svg');
  }

  private usableUrlOrEmpty(url: string | null | undefined): string {
    return this.isUsableMediaUrl(url) ? url : '';
  }
}
